import { ArrowUpRight, Sparkles } from "lucide-react";

export default function MorningBrief({ data, onFocusQueue }) {
  return (
    <section className="morning-brief" data-testid="morning-brief">
      <div className="brief-copy">
        <p className="eyebrow" data-testid="dashboard-date-label">{data.date_label}</p>
        <h1 data-testid="morning-brief-heading">{data.greeting}</h1>
        <p className="brief-summary" data-testid="morning-brief-summary">
          You have <strong>3 decisions that can unlock value</strong> today, plus one shipment
          that needs your attention before the afternoon cutoff.
        </p>
        <button
          className="primary-action"
          type="button"
          onClick={onFocusQueue}
          data-testid="review-priorities-button"
        >
          Review priorities
          <ArrowUpRight size={17} strokeWidth={1.8} />
        </button>
      </div>
      <div className="brief-signal" data-testid="brief-key-signal">
        <span className="sparkle-icon"><Sparkles size={17} strokeWidth={1.8} /></span>
        <div>
          <p className="signal-label">Today’s strongest signal</p>
          <p className="signal-copy">Vintage demand is up 15%</p>
          <p className="signal-caption">Your inventory has room to move.</p>
        </div>
      </div>
    </section>
  );
}